const QUEUED = 'QUEUED';
const SENT = 'SENT';
const ERROR = 'ERROR';
const DELIVERED = 'DELIVERED';
const BOUNCED = 'BOUNCED';
const ITEMS = {
    SENT,
    QUEUED,    
    ERROR,
	DELIVERED,
	BOUNCED
};

export default {
    QUEUED, 
    SENT, 
    ERROR,
	DELIVERED,
	BOUNCED,
    ITEMS
};


// WEBPACK FOOTER //
// ./src/areas/shared/consts/EmailStatusCode.js